import { ChevronRight } from 'src/components/Icons/ChevronRight'
import { memo } from 'react'
import { useMobile } from 'src/hooks/useMobile'
import { useAccountContext } from 'src/components/account/context'
import { InView } from 'react-intersection-observer'
import { useAddressContext } from 'src/components/checkout/steps/shipping/context/address-context'

import { PostalCodeSkeleton } from './PostalCodeSkeleton'
import { PostalCodeReminder } from './PostalCodeReminder'
import { PostalCodeTriggerContent } from './PostalCodeTriggerContent'
import { PostalCodeModal } from '../Modals/PostalCodeModal'
import { usePostalCodeModal } from '../../Hooks/usePostalCodeModal'
import { usePostalCodeViewedEvent } from '../../Hooks/usePostalCodeViewedEvent'

export const PostalCodeInputDesktop = memo(function PostalCodeInputDesktop() {
  const { showModal, setShowModal, ref } = usePostalCodeModal()
  const { isMobile } = useMobile()
  const { postalCode } = useAddressContext()
  const { isLoading } = useAccountContext()
  const onVisibilityChange = usePostalCodeViewedEvent()

  if (isLoading) {
    return (
      <div className="flex justify-between items-center px-4 py-[9px] sm:p-0">
        <div className="w-[140px] h-[32px] sm:h-10 sm:w-[176px]">
          <PostalCodeSkeleton width={140} height={32} />
        </div>
        <div className="w-[140px] h-[32px] sm:h-10 sm:!hidden">
          <PostalCodeSkeleton width={140} height={32} />
        </div>
      </div>
    )
  }

  return (
    <>
      <div ref={ref}>
        <div className="flex justify-center items-center p-3 rounded-md bg-postal-page relative gap-2 px-4 py-2 border-gray border-t-[0.5px] border-b-sm border-b-restructure-background-neutral-5 restructure-small-desktop:border-b-0 sm:z-[10000] sm:p-3 sm:border-0 restructure-small-desktop:p-0">
          <div className="flex justify-center items-center shadow-soft rounded-round min-w-8 h-8">
            <img
              src="https://decathlonstore.vtexassets.com/arquivos/shipping-icon.png"
              alt="Ícone entrega"
              width={24}
              height={24}
              className="w-6 h-6"
            />
          </div>
          <div className="w-full flex justify-between sm:justify-center sm:flex-col">
            <PostalCodeTriggerContent
              postalCode={postalCode}
              onOpenModal={() => setShowModal(true)}
              labelClassName="text-sm whitespace-nowrap"
              buttonClassName="flex items-center gap-1 text-postal-accent text-xs"
              buttonSuffix={
                <ChevronRight color="#3643BA" height={18} width={18} />
              }
            />
          </div>
        </div>
        <InView onChange={onVisibilityChange} triggerOnce>
          <PostalCodeModal showModal={showModal} setShowModal={setShowModal} />
          {!isMobile && <PostalCodeReminder showModal={showModal} />}
        </InView>
      </div>
    </>
  )
})
